import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getCarrierEANDOPerState = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/CarrierEAndOPerState`);
  return data;
};


